import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const PaymentsPage = lazy(() => import('@/containers/Views/Payments/PaymentsPage'));
const PaymentCreatePage = lazy(() => import('@/containers/Views/Payments/PaymentCreatePage'));
const PaymentEditPage = lazy(() => import('@/containers/Views/Payments/PaymentEditPage'));
const PaymentDetailPage = lazy(() => import('@/containers/Views/Payments/PaymentDetailPage'));

const PaymentsRouter = (
  <Route path="payments">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.PaymentOrders} 
          permissions={EBasicActions.Find}
        >
          <PaymentsPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="new" 
      element={(
        <PrivateRoute 
          pageName={EPage.PaymentOrders} 
          permissions={EBasicActions.Create}
        >
          <PaymentCreatePage />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":paymentOrderId" 
      element={(
        <PrivateRoute 
          pageName={EPage.PaymentOrders} 
          permissions={EBasicActions.Find}
        >
          <PaymentDetailPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path=":paymentOrderId/edit" 
      element={(
        <PrivateRoute 
          pageName={EPage.PaymentOrders} 
          permissions={EBasicActions.Create}
        >
          <PaymentEditPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default PaymentsRouter;
